import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicConditionAnnulation = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Vos inscriptions', link: '/topics/inscription'},
    { label: 'Annulations', link: '/topics/inscription/annulations'},
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Même les projets les mieux préparés peuvent rencontrer des imprévus. Les options d’annulation et de remboursement sont toutefois définies 
              directement par les organisateurs, et non par Wodzone. Ces conditions peuvent donc varier d’une compétition à l’autre.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Le règlement intérieur et les conditions générales d’inscription sont définis par les organisateurs et leur responsabilité. 
                Vous pouvez les consulter directement sur la page de description de la compétition, en bas de page, ou juste avant de valider 
                votre inscription. Ces documents sont obligatoires et précisent les conditions d’annulation et de remboursement. 
              </p>
              <p className="help-text">
                Lisez-les attentivement avant de vous inscrire. En vous inscrivant, vous acceptez ces conditions.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicConditionAnnulation